import { heapEvent } from '@equipmentshare/heaper'
import ConvertParts from '../convert-parts/convert-parts'

export default function getConvertPartsModal( storePart: any, onSuccess?: () => void ) {
	return {
		component: ConvertParts,
		componentProps: { storePart },
		label: 'Convert Items',
		onSuccess,
		onXClick: () => heapEvent( 'Inventory - Convert Items Modal - Click - X button', {} ),
	}
}
